const globalConfig = {
  countryHash: {
    'SA' : 'Saudi Arabia',
    'BH' : 'Bahrain',
    'UAE': 'United Arab Emirates',
    'OM': 'Oman',
    'KW': 'Kuwait'
  },
  customerGroups: {
    0 : 'NOT LOGGED IN',
    1 : 'General',
    2 : 'Wholesale',
    3 : 'Retailer',
    4 : 'Lead Page Customers'
  },
  itemReturnTableHeader: [
    // { label: 'Image', hasTooltip: false },
    { label: 'Product', hasTooltip: false },
    { label: 'Price', hasTooltip: false },
    { label: 'Return Reason', hasTooltip: true },
    { label: 'Item Condition', hasTooltip: true },
    { label: 'Resolution', hasTooltip: true },
    { label: 'Purchased Qty', hasTooltip: true },
    { label: 'Return Qty', hasTooltip: true }
  ],
  rmaStatus: {
    "processed_closed" : { text: 'Resolved', color: '#00C853' },
    "authorized" : { text: 'Authorized', color: '#FB8C00' },
    "authorized_part" : { text: 'Partly uthorized', color: '#FB8C00' }, 
    "rejected" : { text: 'Rejected', color: '#F44500' },
    "rejected_part" : { text: 'Partly rejected', color: '#F44500' },
    "new" : { text: 'New', color: '#FB8C00' },
    "approved" : { text: 'Approved', color: '#006400'},
    "approved_part" : { text: 'Partly Approved', color: '#006400' },
    "received" : { text: 'Received', color: '#2C7C7C' },
    "received_part" : { text: 'Partly Received', color: '#2C7C7C' },
    "closed" : { text: 'Closed', color: '#000' }
  },
  shipmentMethod: {
    	esnad_esnad	:'Shababuna',
	amazon_amazon	:'Shababuna',
	freeshipping_freeshipping	:'Shababuna',
	helix_helix	:'Shababuna',
	hnak_hnak	:'Shababuna',
	ibflatrate1_ibflatrate1	:'Shababuna',
	ibflatrate2_ibflatrate2	:'Shababuna',
	saudipost_saudipost	:'Shababuna',
	webkularamex_ONP	:'Aramex',
	webkularamex_PPX	:'Aramex'
  },
  PaymentMethod : {
    cod:'Cash On Delivery',
    online:'Credit / Debit Cards',
    apple:'ApplePay',
    mada:'MadaPay',
    tamara:'TamaraPay',
    tabby:'TabbyPay'




  },
  shipmentStatus : {
    CNADR:'Customer not available ',
    DLVD:'Delivered',
    INPR:'In Transit',
    NA:'Not Applicable',
    OFD:'Out for delivery',
    RTND:'Returned to shipper'
  }
}

export default globalConfig